// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bhl_a bik_bi"};